import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserInput from '../components/UserInput';
import AccountButton from '../components/AccountButton';
import Divider from '../components/Divider';
import '../components/SignIn.css';
import { InputContext } from '../components/InputContext';

const baseURL = process.env.REACT_APP_API_URL;


const SignIn = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { setGlobalUser } = useContext(InputContext);

  const handleSignIn = (e) => {
    e.preventDefault(); 

    if (!username || !password) {
      alert('Missing username and/or password.');
      return;
    }

    fetch(`${baseURL}/acc/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    })

    .then(res => res.json())
    .then(data => {
      if (data.error) { alert(data.error); }
      else {
        setGlobalUser(data.username, data.admin);
        navigate('/home');
    }})

    .catch(err => {
      console.error('Login error', err);
      alert('Failed to login. Please try again.');
    });
  };

  const handleCreateAcc = () => { navigate('/createAcc'); };

  return (
    <div className="signin-container">
      <div className="title">RecipeShare</div>

      <div className="signin-box">
        <h2>Sign In</h2>
        <form>
          <UserInput type="text" placeholder="Username" 
            value={username} onChange={(e) => setUsername(e.target.value)}/>
          <UserInput type="password" placeholder="Password"
            value={password} onChange={(e) => setPassword(e.target.value)}/>
          <AccountButton text="Sign In" onClick={handleSignIn}/>
        </form>
        
        <Divider/>
        <AccountButton text="Create Account" create onClick={handleCreateAcc}/>
      </div>
    </div>
  );
};

export default SignIn;
